export default "__VITE_ASSET__C$hk9MBf__"